import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=auth
  const [token, setToken] = useState(() => localStorage.getItem("tilt_token"));

  const applyToken = useCallback((t) => {
    if (t) {
      localStorage.setItem("tilt_token", t);
      axios.defaults.headers.common["Authorization"] = `Bearer ${t}`;
    } else {
      localStorage.removeItem("tilt_token");
      delete axios.defaults.headers.common["Authorization"];
    }
    setToken(t);
  }, []);

  useEffect(() => {
    let active = true;
    const t = localStorage.getItem("tilt_token");
    if (!t) {
      setUser(false);
      return;
    }
    axios.defaults.headers.common["Authorization"] = `Bearer ${t}`;
    axios
      .get(`${API}/auth/me`)
      .then(({ data }) => active && setUser(data))
      .catch(() => {
        if (active) {
          applyToken(null);
          setUser(false);
        }
      });
    return () => {
      active = false;
    };
  }, [applyToken]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    applyToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const adoptSession = (t, u) => {
    applyToken(t);
    setUser(u);
  };

  const logout = () => {
    applyToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, adoptSession, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
